import { useCollapseStore } from "@/Stores/collapse";
import { computed } from "vue";

export function useCollapse(storeKey) {
    const collapseStore = useCollapseStore();

    const isCollapsed = computed(() => {
        return collapseStore[storeKey] || false;
    });

    const handleCollapseChange = () => {
        if (!collapseStore[storeKey]) {
            console.error(
                "The specified store key is not present in the collapse store."
            );
        }

        collapseStore[storeKey] = !collapseStore[storeKey];
    };

    return {
        isCollapsed,
        handleCollapseChange,
    };
}
